import { tsValidateArray, tsValidateBoolean, tsValidateOptionalObject, tsValidateString, tsValidateUniqueId, tsValidateValue } from '@nu-art/ts-common';
import { fishboneDirections } from './types.js';
const Validator_FishBoneRibItem = {
    variableIds: tsValidateArray(tsValidateUniqueId),
    shortName: tsValidateString(-1, false),
};
const Validator_FishboneRib = {
    ribItems: tsValidateArray(Validator_FishBoneRibItem),
    slantDividers: tsValidateBoolean(false)
};
export const Validator_Fishbone = {
    key: tsValidateString(),
    label: tsValidateString(),
    direction: tsValidateValue([...fishboneDirections]),
    ribs: tsValidateArray(Validator_FishboneRib),
    head: tsValidateOptionalObject(Validator_FishBoneRibItem),
    tail: tsValidateOptionalObject(Validator_FishBoneRibItem),
};
//# sourceMappingURL=validation.js.map